// removed by extract-text-webpack-plugin
module.exports = {"button":"_1oHfJ","toolButton":"_3gCze","page":"_3EsOi","lockToggle":"_3Rqg8","info":"_1muzq","cover":"_2_rpT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/album/AlbumInfo.css
// module id = 816
// module chunks = 0